import createCache from "@emotion/cache";
import rtlPlugin from "stylis-plugin-rtl";

import { isSSR } from "./utils/helpers/isSSR";

let insertionPoint;

if (!isSSR()) {
  insertionPoint = document.querySelector(
    'meta[name="emotion-insertion-point"]',
  );
}

export const createEmotionCache = (isRtl = false) => {
  const cache = createCache({
    key: isRtl ? "mui-rtl" : "mui",
    stylisPlugins: isRtl ? [rtlPlugin] : [],
    prepend: true,
    insertionPoint,
  });

  return cache;
};
